<template>
	<div>驻派数据</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>